/**
 * @generated SignedSource<<3cad7caf7b4c8568de54524d34b3adb1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type AnalyticsByLine_query$data = {
  readonly contentAnalyticsViewers: {
    readonly count: number;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
  readonly " $fragmentType": "AnalyticsByLine_query";
};
export type AnalyticsByLine_query$key = {
  readonly " $data"?: AnalyticsByLine_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnalyticsByLine_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentId"
    }
  ],
  "kind": "Fragment",
  "name": "AnalyticsByLine_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "contentId",
          "variableName": "contentId"
        }
      ],
      "concreteType": "ContentAnalyticsViewers",
      "kind": "LinkedField",
      "name": "contentAnalyticsViewers",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "count"
        }
      ]
    },
    {
      "alias": "user",
      "args": [
        {
          "kind": "Literal",
          "name": "current",
          "value": true
        }
      ],
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "confluence_atlassianUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "ConfluenceUser",
          "kind": "LinkedField",
          "name": "confluence",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "permissionType"
            }
          ]
        }
      ],
      "storageKey": "confluence_atlassianUser(current:true)"
    }
  ],
  "type": "Query"
};

(node as any).hash = "def703425dec5060f92bf670fc8e1c37";

export default node;
